module.exports = __webpack_public_path__ + "img/photo5.cb205250.jpg";